export const CATEGORIES = ["barber", "stylist", "nail_tech"] as const;
export type Category = (typeof CATEGORIES)[number];

export const CATEGORY_LABELS: Record<Category, string> = {
  barber: "Barber",
  stylist: "Hair Stylist",
  nail_tech: "Nail Tech",
};
